/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    asyncDefaults,
    makeAsyncReducer,
    makeAsyncResetReducer,
    mergeReducers,
} from 'ui-permit/shared-components/utils/async';
import { PREFIX } from '../constants';
import * as ACTIONS from '../constants/actions';

const fetchPermit = makeAsyncReducer(ACTIONS.FETCH_PERMIT);
const resetPermit = makeAsyncResetReducer(ACTIONS.RESET_PERMIT, []);

const permit = mergeReducers(
    asyncDefaults({
        title: '',
        description: {
            description: '',
        },
    }),
    PREFIX,
    fetchPermit,
    resetPermit
);

export default permit;

export const selectors = {
    getPermit: (state) => state.huntingpermit.permit.data,
    getPermitError: (state) => state.huntingpermit.permit.error,
    getPermitLoading: (state) => state.huntingpermit.permit.loading,
    getPermitLoaded: (state) => state.huntingpermit.permit.loaded,
    getPermitWithoutCamelCase: (state) => state.huntingpermit.permit.data,

    getRecarea: (state) => state.huntingpermit.recarea.data,
};

const fetchRecarea = makeAsyncReducer(ACTIONS.FETCH_RECAREA);
export const recarea = mergeReducers(asyncDefaults([]), PREFIX, fetchRecarea);
